import Vue from 'vue'
import Vuex from 'vuex'
import {USPS_LIST} from "../components/_common/uspsList";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isIframeMode: false,
    currentCarModel: 'jetta',
    uspIndex: null,
    uspWindowVisible: false,
    carColor: null,
    carWheels: null,
    carInteriorColor: null,
    zoom: 7,
    insideCabine: false,
    fullScreen: false
  },
  mutations: {
    setCarModel(state, model) {
      state.currentCarModel = model
    },
    setFullScreen(state, isFullScreen) {
      state.fullScreen = isFullScreen
    },
    setIframeMode(state, isFrame) {
      state.isIframeMode = isFrame
    },
    setInsideCabine (state, inside) {
      state.insideCabine = inside
    },
    setZoom (state, zoom) {
      state.zoom = zoom
    },
    nextUsp(state) {
      // if (state.uspWindowVisible) {
        let currentIndex = state.uspIndex
        if (currentIndex !== null) {
          currentIndex++
        } else {
          currentIndex = 0
        }
        if (currentIndex >= USPS_LIST[state.currentCarModel].length) {
          currentIndex = 0
        }
        state.uspIndex = currentIndex
      // }

      state.uspWindowVisible = true
    },
    prevUsp(state) {
      // if (state.uspWindowVisible) {
        if (currentIndex !== null) {
          currentIndex++
        } else {
          currentIndex = 0
        }
        let currentIndex = state.uspIndex
        currentIndex--
        if (currentIndex < 0) {
          currentIndex = USPS_LIST[state.currentCarModel].length - 1
        }
        state.uspIndex = currentIndex
      // }

      state.uspWindowVisible = true
    },

    showUspWindow(state) {
      state.uspWindowVisible = true
    },
    hideUspWindow(state) {
      state.uspWindowVisible = false
    },
    setCarColor(state, color) {
      state.carColor = color
    },
    setCarWheels(state, wheels) {
      state.carWheels = wheels
    },
    setCarInteriorColor(state, color) {
      state.carInteriorColor = color
    },
    setUspByCameraName(state, cameraName) {
      for (let index in USPS_LIST[state.currentCarModel]) {
        let item = USPS_LIST[state.currentCarModel][index]
        if (item.pointName === cameraName) {
          state.uspIndex = index
          state.uspWindowVisible = true
          const eventName = item.gaLabel
          try {
            const parent = window.parent
            console.log({
              "type" : "iframe",
              "event": "custom.postMessage",
              "eventAction": "showroom." + eventName,
              "eventCategory": 'showroom_' + state.currentCarModel
            })
            if (typeof parent != "undefined" && parent != window) {
              if (typeof parent.postMessage != "undefined") {
                let message = {
                  "type" : "iframe",
                  "event": "custom.postMessage",
                  "eventAction": "showroom." + eventName,
                  "eventCategory": 'showroom_' + state.currentCarModel
                }

                const messageJSON = JSON.stringify(message);
                parent.postMessage(messageJSON, "*");
              }
            } else {
              console.log('postMessage method allowed only inside iframe')
            }
          } catch(err){
            console.log(err)
          }
        }
      }
    }
  },
  actions: {
    setCarModel({commit}, value) {
      commit('setCarModel', value)
    },
    setFullScreen({commit}, value) {
      commit('setFullScreen', value)
    },
    enableIframe({commit}) {
      commit('setIframeMode', true)
    },
    disableIframe({commit}) {
      commit('setIframeMode', false)
    },
    setInsideCabine({commit}, inside) {
      commit('setInsideCabine', inside)
    },
    setZoom({commit}, zoom) {
      commit('setZoom', zoom)
    },
    nextUsp({commit}) {
      commit('nextUsp')
    },
    prevUsp({commit}) {
      commit('prevUsp')
    },
    setUspByCameraName({commit}, cameraName) {
      commit('setUspByCameraName', cameraName)
    },
    showUspWindow({commit}) {
      commit('showUspWindow')
    },
    hideUspWindow({commit}) {
      commit('hideUspWindow')
    },
    setCarColor({commit}, color) {
      commit('setCarColor', color)
    },
    setCarWheels({commit}, wheels) {
      commit('setCarWheels', wheels)
    },
    setCarInteriorColor({commit}, color) {
      commit('setCarInteriorColor', color)
    }
  },
  getters: {
    carModel: state => {
      return state.currentCarModel
    },
    fullScreen: state => {
      return state.fullScreen
    },
    isIframeMode: state => {
      return state.isIframeMode
    },
    insideCabine: state => {
      return state.insideCabine
    },
    zoom: state => {
      return state.zoom
    },

    carColor: state => {
      return state.carColor
    },
    carWheels: state => {
      return state.carWheels
    },
    carInteriorColor: state => {
      return state.carInteriorColor
    },
    uspData: state => {
      return USPS_LIST[state.currentCarModel][state.uspIndex]
    },

    uspWindowVisible: state => {
      return state.uspWindowVisible
    }
  },
  modules: {
  }
})
